import { AttestationHistoryTableCollapse } from '@core/components/dashboard/evidence-based-approach/evidence-components/subcomponents/attestation-history/attestation-history-table.collapse';
import { html } from '@shared/utils/rendering/html';

export const AttestationHistoryColumns = [
    {
        displayName: 'Change Type',
        sortColumnName: 'changeType',
        dataType: 'chip',
        dataKey: 'changeType',
        converter: (value) => {
            return { label: { text: value }, value, css: '' };
        },
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Date Updated',
        sortColumnName: 'changeDate',
        dataType: 'date',
        dataKey: 'changeDate',
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Modified By',
        sortColumnName: 'changedBy',
        dataType: 'string',
        dataKey: 'changedBy',
        settings: { sort: true, filter: false, multiple: false },
    },
    {
        displayName: 'Description',
        sortColumnName: 'changeDescription',
        dataType: 'string',
        dataKey: 'changeDescription',
        settings: { sort: false, filter: false, multiple: false },
    },
];

export const AttestationHistorySorting = {
    sortByColumn: 'changeDate',
    sortByDescending: true,
    callback: (data) => {},
};

export const AttestationHistoryPaging = {
    paginationEvent: () => {},
    paginationData: {
        pageNumber: 1,
        pageSize: 10,
        total: 10,
    },
    pageSizeOptions: [
        { value: Number.MAX_SAFE_INTEGER, text: 'All' },
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 20, text: '20' },
    ],
    defaultPageSize: {
        value: 10,
        text: '10',
    },
};

export const AttestationHistoryFilters = {
    sorting: AttestationHistorySorting,
    pagination: AttestationHistoryPaging,
    advancedFilters: null,
};

export const AttestationHistoryTableConfiguration = {
    columns: AttestationHistoryColumns,
    filters: AttestationHistoryFilters,
    actions: null,
    collapse: {
        enabled: true,
        render: (data) => html`<${AttestationHistoryTableCollapse} rowData=${data} />`,
    },
};
